import React from "react";
import NavBar from "../nav-bar/Nav";
import { Accordion } from "react-bootstrap";
import './faq.scss';

export default function FAQ() {
  const questions = [
    {
      id: 'collapseOne',
      question: 'How does this work?',
      answer: `SignetRisk utilizes delegated read-only limited access credentials that you provide to fetch and present information from your existing cloud provider accounts. These API keys must be configured with a restricted role account that limits access in scope to be read only and is restricted to only the security compliance data in your cloud provider account. For example, for AWS, you would need to create an account that would have read-only access to the AWS Security Hub service and configure these keys in your SignetRisk account. SignetRisk would then fetch the appropriate data elements and compile them into a summary report.`,
    },
    {
      id: 'collapseTwo',
      question: 'What cloud service providers do you currently support?',
      answer: `The service currently only supports reports based on AWS Security Hub data, though we have plans to extend this to Google Cloud Platform and Microsoft Azure security services as well.`,
    },
    {
      id: 'collapseThree',
      question: 'What cloud compliance standards are supported?',
      answer: `The SignetRisk report currently only includes support for AWS Security Hub based compliance tests. The three standards that are included in the SignetRisk report are: "CIS AWS Foundations Benchmark", "AWS Foundational Security Best Practices", and "PCI DSS".`,
    },
    {
      id: 'collapseFour',
      question: 'How do I configure my AWS account to use these reports?',
      answer: `We are happy to work with you to get you started. We provide a simple python script that does all the work. You are welcome to audit or modify the script as you like. Just be sure to allow our AWS account to be linked to your Security Hub service.`,
    },
    {
      id: 'collapseFive',
      question: 'What roles/permissions do I need to create for SignetRisk reports?',
      answer: `In order to get started you need to use an access role that has the ability to create IAM roles in your AWS account. The python script that we provide will help you get started by creating a new role in your account that will link your AWS Security Hub information to our AWS data connector. Once this is in place we will have access to just the Security Hub information in your AWS account and nothing else. There is no other access that is needed other than this.`,
    },
    {
      id: 'collapseSix',
      question: 'Do you report on data for all regions of AWS?',
      answer: `Yes. You can configure reporting on multiple regions via the setup script that we provide.`,
    },
  ];

  return (
    <div className="faq-page">
      <NavBar />
      <div className="faq-page__hero">
        <div className="container">
          <p className="faq-page__eyebrow">Support</p>
          <h1 className="faq-page__title">Frequently asked questions</h1>
          <p className="faq-page__lead">
            Browse common questions about how SignetRisk works, cloud support, and setup.
            Still stuck? Email us at{' '}
            <a href="mailto:support@signetrisk.com">support@signetrisk.com</a>.
          </p>
        </div>
      </div>

      <div className="container faq-page__content">
        <Accordion defaultActiveKey="0" className="faq-accordion">
          {questions.map((item, index) => (
            <Accordion.Item eventKey={String(index)} key={item.id} className="faq-accordion__item">
              <Accordion.Header>
                <span className="faq-accordion__index">{String(index + 1).padStart(2, '0')}</span>
                <span className="faq-accordion__question">{item.question}</span>
              </Accordion.Header>
              <Accordion.Body>
                <p>{item.answer}</p>
              </Accordion.Body>
            </Accordion.Item>
          ))}
        </Accordion>

        <div className="faq-cta">
          <div className="faq-cta__copy">
            <h2>Still have questions?</h2>
            <p>We’re happy to help with setup, integrations, or product fit.</p>
          </div>
          <a className="btn btn-primary" href="mailto:support@signetrisk.com">
            Contact support
          </a>
        </div>
      </div>
    </div>
  );
}
